module.exports = __webpack_public_path__ + "img/orders-arrow.b25de38f.svg";